import type { ITarea } from "../../../modelos/Tarea/entidades/ITarea";
import type { ITareaFormulario } from "../interfaces/ITareaFormulario";

export const convertirFormularioATarea = (formulario: ITareaFormulario): ITarea => {
    const tarea: ITarea = {
        Id: formulario.Id,
        ProyectoId: formulario.ProyectoId,
        EquipoId: formulario.EquipoId,
        TipoServicioId: formulario.TipoServicioId,
        EstadoId: formulario.EstadoId,
        FechaInicio: formulario.FechaInicio,
        CreadaUtc: formulario.CreadaUtc,
        FechaFin: formulario.FechaFin,
        EsEmergencia: formulario.EsEmergencia,
        CreadaPor: formulario.CreadaPor,
        AsignadaA: formulario.AsignadaA,
        CausalEmergenciaId: formulario.CausalEmergenciaId,
        ModulosChecklist: formulario.ModulosChecklist,
        LLegadaPunto: formulario.LLegadaPunto,
        FinalizacionPunto: formulario.FinalizacionPunto,
        TipoVisitaInstalacionId: formulario.TipoVisitaInstalacionId,
        SeccionesChecklist: formulario.SeccionesChecklist,
    };

    return tarea;
};

export const convertirTareaAFormulario = (tarea: ITarea): ITareaFormulario => {
    return {
        ...tarea,
        // Agregamos los campos adicionales del formulario
        ProyectoId: tarea.ProyectoId,
        ClienteId: tarea.Equipo?.Proyecto?.ClienteId || 0,
        NumeroContrato: tarea.Equipo?.Proyecto?.Contrato?.Numero || '',
        CodigoEquipo: tarea.Equipo?.Codigo || '',
        // Duracion en minutos calculada a partir de FechaInicio y FechaFin
        Duracion: (() => {
            try {
                if (!tarea.FechaInicio || !tarea.FechaFin) return 0;
                const inicio = new Date(tarea.FechaInicio as string);
                const fin = new Date(tarea.FechaFin as string);
                if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return 0;
                const diffMin = Math.round((fin.getTime() - inicio.getTime()) / 60000);
                return diffMin > 0 ? diffMin : 0;
            } catch {
                return 0;
            }
        })()
    };
};